import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Service Role Key para operações administrativas
const supabaseServiceKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0enFjZWRwYnZ3YWJ6enFjZnVmIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1NDQyODIwMSwiZXhwIjoyMDcwMDA0MjAxfQ.LvznULwNQoIOePAUuyTVU08BWCfJ9coSvUm39zMfjv8';

console.log('Supabase URL:', supabaseUrl);
console.log('Supabase Key exists:', !!supabaseAnonKey);

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Environment variables:', {
    url: supabaseUrl,
    keyExists: !!supabaseAnonKey,
    allEnvVars: Object.keys(process.env).filter(key => key.startsWith('REACT_APP_'))
  });
  throw new Error('Missing Supabase environment variables');
}

// Cliente padrão para operações normais (com anon key)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Cliente admin para operações administrativas (com service role key)
export const supabaseAdmin = createClient(supabaseUrl, supabaseServiceKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false
  }
});
